import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Select,
  VStack,
  Text,
  Box,
  Icon,
  HStack,
  Divider,
  useToast,
} from '@chakra-ui/react';
import { MdLocationOn } from 'react-icons/md';

// ─── Tunisia geographic data ────────────────────────────────────────────────
const TUNISIA_DATA = {
  'تونس': [
    'تونس المدينة', 'باب باب', 'باب سويقة', 'العمران', 'العمران الأعلى',
    'التحرير', 'المنيهلة', 'سيدي البشير', 'الزهور', 'الحرائرية',
    'سيدي حسين', 'الوردية', 'الكبارية', 'سيدي البشير', 'جبل الجلود',
    'حلق الوادي', 'الكرم', 'المرسى', 'قرطاج', 'سيدي أبو سعيد',
    'الجمهورية', 'الدندان', 'البطان', 'حمام الشط', 'بن عروس'
  ],
  'أريانة': [
    'أريانة المدينة', 'سكرة', 'رواد', 'قلعة الأندلس', 'سيدي ثابت',
    'حي التضامن', 'منيهلة', 'التضامن', 'المنار', 'الغزالة'
  ],
  'بن عروس': [
    'بن عروس', 'مدينة حمام', 'فوشانة', 'موروج', 'مقرين',
    'المروج', 'بومهل البساتين', 'الزهراء', 'حمام لف', 'النقاز',
    'المحمدية', 'الملاسين'
  ],
  'منوبة': [
    'منوبة', 'دوار هيشر', 'وادي الليل', 'المرناقية', 'البطان',
    'طبربة', 'الجديدة', 'تاجر موراس'
  ],
  'نابل': [
    'نابل', 'دار شعبان الفهري', 'بني خيار', 'قرمبالية', 'همامت',
    'يسمبول', 'قليبية', 'منزل تميم', 'الميدة', 'تازركة',
    'سليمان', 'منزل بوزلفة', 'بني خلاد'
  ],
  'زغوان': [
    'زغوان', 'الزريبة', 'بئر مشارقة', 'الفاحص', 'الناظور', 'صواف'
  ],
  'بسكرة / بنزرت': [
    'بنزرت', 'تونكر', 'ماطر', 'العالية', 'راس الجبل', 'الجومين',
    'أوتيك', 'غار الملح', 'منزل جميل', 'العزيب',
    'منزل عبد الرحمان', 'تبورقة', 'سيدي علي البحري'
  ],
  'بنزرت': [
    'بنزرت', 'تونكر', 'ماطر', 'العالية', 'راس الجبل', 'الجومين',
    'أوتيك', 'غار الملح', 'منزل جميل', 'العزيب',
    'منزل عبد الرحمان', 'تبورقة', 'سيدي علي البحري'
  ],
  'باجة': [
    'باجة الشمالية', 'باجة الجنوبية', 'عمدون', 'نفزة', 'تيبار',
    'تستور', 'قبلاط', 'مجاز الباب'
  ],
  'جندوبة': [
    'جندوبة', 'جندوبة الشمالية', 'بوسالم', 'طبرقة', 'عين دراهم',
    'فرنانة', 'غار ديماو', 'وادي مليز', 'بلطة بوعوان'
  ],
  'الكاف': [
    'الكاف الغربي', 'الكاف الشرقي', 'نبر', 'ساقية سيدي يوسف',
    'تاجروين', 'قلعة سنان', 'القلعة الخصبة', 'جرندوبة',
    'القصور', 'الدهماني'
  ],
  'سليانة': [
    'سليانة الشمالية', 'سليانة الجنوبية', 'رقادة', 'بوعرادة',
    'قعفور', 'الكريب', 'برقو', 'مكثر', 'الروحية'
  ],
  'سوسة': [
    'سوسة المدينة', 'سوسة الرياض', 'سوسة الجوفرة', 'سوسة سيدي عبيد',
    'حمام سوسة', 'أكودة', 'قلعة الكبرى', 'سيدي بو علي',
    'هرقلة', 'النفيضة', 'بوفيشة', 'قنبلة', 'زاوية سوسة',
    'الزاوية - الحاجب - الدشرة'
  ],
  'المنستير': [
    'المنستير', 'الوردانين', 'الساحلين', 'زرمدين', 'بني حسان',
    'جمال', 'بنبلة', 'المكنين', 'البقلطة', 'قصر هلال',
    'قصيبة المديوني', 'صيادة - لمطة - بوحجر'
  ],
  'المهدية': [
    'المهدية', 'بومرداس', 'أولاد الشامخ', 'الرقادة', 'الشابة',
    'ملولش', 'الجم', 'الشبيكة', 'صواف', 'قصور الساف', 'سيدي علوان'
  ],
  'صفاقس': [
    'صفاقس المدينة', 'صفاقس الغربية', 'ساقية الدائر', 'ساقية الزيت',
    'صفاقس الجنوبية', 'طينة', 'عقارب', 'جبنيانة', 'العامرة',
    'الحنشة', 'منزل شاكر', 'الغريبة', 'بئر علي بن خليفة', 'الصخيرة',
    'المحرس', 'قرقنة'
  ],
  'القيروان': [
    'القيروان الشمالية', 'القيروان الجنوبية', 'الشبيكة', 'السبيخة',
    'العلا', 'حفوز', 'العوينات', 'حاجب العيون', 'نصرالله',
    'الشراردة', 'بوحجلة'
  ],
  'القصرين': [
    'القصرين الشمالية', 'القصرين الجنوبية', 'فريانة', 'فوسانة',
    'تالة', 'حيدرة', 'الزهور', 'سبيطلة', 'سبيبة', 'جدليان', 'العيون'
  ],
  'سيدي بوزيد': [
    'سيدي بوزيد الغربية', 'سيدي بوزيد الشرقية', 'سيدي علي بن عون',
    'منزل بوزيان', 'المكناسي', 'سوق الجديد', 'المزونة', 'الرقاب',
    'أولاد حفوز', 'جلمة', 'بئر الحفي', 'السعيدة'
  ],
  'قابس': [
    'قابس المدينة', 'قابس الغربية', 'قابس الجنوبية', 'غنوش',
    'الحامة', 'ماطماطة', 'ماطماطة الجديدة', 'مارث', 'دخيلة توجان',
    'المطوية', 'منزل الحبيب', 'الزارات', 'وذرف'
  ],
  'مدنين': [
    'مدنين الشمالية', 'مدنين الجنوبية', 'بن قردان', 'جربة أجيم',
    'جربة ميدون', 'جربة حومة السوق', 'سيدي مخلوف', 'بني خداش', 'جرجيس'
  ],
  'تطاوين': [
    'تطاوين الشمالية', 'تطاوين الجنوبية', 'البئر الأحمر', 'سمار',
    'غمراسن', 'ذهيبة'
  ],
  'قفصة': [
    'قفصة الشمالية', 'قفصة الجنوبية', 'سيدي عيش', 'القصر',
    'أم العرائس', 'الرديف', 'المتلوي', 'المضيلة', 'البلابة',
    'زانوش', 'القطار'
  ],
  'توزر': [
    'توزر', 'دقاش', 'حاجب العيون', 'نفطة', 'الحامة'
  ],
  'قبلي': [
    'قبلي الشمالية', 'قبلي الجنوبية', 'سوق الأحد', 'دوز الشمالية',
    'دوز الجنوبية', 'الفوار'
  ],
};

const WILAYAT = Object.keys(TUNISIA_DATA);

// ─── Component ───────────────────────────────────────────────────────────────
const GicLocationModal = ({ isOpen, onSubmit, isLoading }) => {
  const [selectedWilaya, setSelectedWilaya] = useState('');
  const [selectedMoughataa, setSelectedMoughataa] = useState('');
  const toast = useToast();

  const moughataat = selectedWilaya ? (TUNISIA_DATA[selectedWilaya] || []) : [];

  const handleWilayaChange = (e) => {
    setSelectedWilaya(e.target.value);
    setSelectedMoughataa(''); // reset sub-selection
  };

  const handleSubmit = () => {
    if (!selectedWilaya || !selectedMoughataa) {
      toast({
        title: 'حقول مطلوبة',
        description: 'يرجى اختيار الولاية والمعتمدية',
        status: 'warning',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    onSubmit(selectedWilaya, selectedMoughataa);
  };

  return (
    <Modal
      isOpen={isOpen}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
      size="md"
    >
      <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(6px)" />
      <ModalContent dir="rtl" borderRadius="2xl" overflow="hidden" boxShadow="2xl">
        {/* Gradient header */}
        <Box
          bgGradient="linear(135deg, #1a365d 0%, #2b6cb0 50%, #3182ce 100%)"
          px={6}
          py={5}
        >
          <HStack spacing={3}>
            <Icon as={MdLocationOn} color="yellow.300" boxSize={7} />
            <VStack align="flex-start" spacing={0}>
              <Text color="white" fontWeight="bold" fontSize="lg">
                تحديد الموقع الجغرافي
              </Text>
              <Text color="blue.100" fontSize="sm">
                مطلوب لطلاب Gestion Information Complète
              </Text>
            </VStack>
          </HStack>
        </Box>

        <ModalBody py={6} px={6}>
          <Text color="gray.600" mb={5} fontSize="sm" textAlign="right">
            يرجى تحديد موقعك الجغرافي مرة واحدة فقط. هذه المعلومات تساعدنا على
            خدمتك بشكل أفضل وتنظيم الدروس في منطقتك.
          </Text>

          <VStack spacing={5}>
            {/* ولاية */}
            <FormControl isRequired>
              <FormLabel fontWeight="semibold" color="gray.700" textAlign="right">
                الولاية
              </FormLabel>
              <Select
                placeholder="اختر الولاية"
                value={selectedWilaya}
                onChange={handleWilayaChange}
                textAlign="right"
                borderColor="blue.200"
                _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px #3182ce' }}
                borderRadius="lg"
                size="lg"
              >
                {WILAYAT.map((w) => (
                  <option key={w} value={w}>{w}</option>
                ))}
              </Select>
            </FormControl>

            {/* معتمدية */}
            <FormControl isRequired isDisabled={!selectedWilaya}>
              <FormLabel fontWeight="semibold" color="gray.700" textAlign="right">
                المعتمدية
              </FormLabel>
              <Select
                placeholder={selectedWilaya ? 'اختر المعتمدية' : 'اختر الولاية أولاً'}
                value={selectedMoughataa}
                onChange={(e) => setSelectedMoughataa(e.target.value)}
                textAlign="right"
                borderColor="blue.200"
                _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px #3182ce' }}
                borderRadius="lg"
                size="lg"
              >
                {moughataat.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </Select>
            </FormControl>
          </VStack>
        </ModalBody>

        <Divider />

        <ModalFooter justifyContent="center" py={4}>
          <Button
            bgGradient="linear(to-r, #1a365d, #3182ce)"
            color="white"
            size="lg"
            px={10}
            borderRadius="xl"
            onClick={handleSubmit}
            isLoading={isLoading}
            loadingText="جاري الحفظ..."
            _hover={{ bgGradient: 'linear(to-r, #2b6cb0, #2c5282)', transform: 'translateY(-1px)', boxShadow: 'lg' }}
            _active={{ transform: 'translateY(0)' }}
            transition="all 0.2s"
            isDisabled={!selectedWilaya || !selectedMoughataa}
          >
            تأكيد الموقع
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default GicLocationModal;
